module.exports = __webpack_public_path__ + "assets/panels/unknown-dc864de94be5ae4d93d04107dbcd9926.svg";